import React from "react";

import { LoadingIcon } from "../SVGIcons";

interface LoadingIndicatorModalProps {
  message?: string;
}

const LoadingIndicatorModal: React.FC<LoadingIndicatorModalProps> = ({
  message = "処理中...",
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 200,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 中央のモーダル */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px 32px",
          display: "flex",
          alignItems: "center",
          gap: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <LoadingIcon className="w-8 h-8 text-blue-500" />
        <p
          style={{
            color: "#374151",
            fontWeight: 500,
            fontSize: "16px",
            margin: 0,
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingIndicatorModal;
